interface SmartyAdministrativeArea {
  readonly administrativeArea?: string;
  readonly administrativeAreaShort?: string;
  readonly administrativeAreaLong?: string;
}

export interface StateOption {
  readonly isoCode: string;
  readonly name: string;
}

function normalize(value: string | undefined): string {
  return value?.trim() ?? "";
}

function findStateByIsoCode(
  stateOptions: readonly StateOption[],
  value: string,
): StateOption | undefined {
  const normalizedValue = value.toUpperCase();
  return stateOptions.find(
    (state) => state.isoCode.toUpperCase() === normalizedValue,
  );
}

function findStateByName(
  stateOptions: readonly StateOption[],
  value: string,
): StateOption | undefined {
  const normalizedValue = value.toLowerCase();
  return stateOptions.find(
    (state) => state.name.toLowerCase() === normalizedValue,
  );
}

export function resolveSmartyAdministrativeArea(
  result: SmartyAdministrativeArea | undefined,
  stateOptions: readonly StateOption[] = [],
): string {
  const administrativeArea = normalize(result?.administrativeArea);
  const administrativeAreaShort = normalize(result?.administrativeAreaShort);
  const administrativeAreaLong = normalize(result?.administrativeAreaLong);

  if (stateOptions.length === 0) {
    return (
      administrativeArea || administrativeAreaLong || administrativeAreaShort
    );
  }

  for (const candidate of [
    administrativeAreaShort,
    administrativeArea,
    administrativeAreaLong,
  ]) {
    if (!candidate) continue;

    const matchingState =
      findStateByIsoCode(stateOptions, candidate) ??
      findStateByName(stateOptions, candidate);

    if (matchingState) {
      return matchingState.isoCode;
    }
  }

  return (
    administrativeArea || administrativeAreaLong || administrativeAreaShort
  );
}
